<template>
  <div class="service-detail-page">
    <div class="hero-gradient-overlay"></div>
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>
    <v-container class="main-section py-16">
      <div v-if="service" class="content-wrapper">
        <div class="service-hero mb-12 animate-fade-in">
          <div class="hero-badge mb-4">
            <v-icon small color="#f46523" class="mr-2">mdi-star</v-icon>
            <span>Premium Service</span>
          </div>
          <h1 class="service-title mb-4">
            {{ service.service }}
          </h1>
          <p class="service-description">
            {{ service.description }}
          </p>
          <div class="service-meta mt-6">
            <div class="meta-item">
              <v-icon color="#f46523">mdi-clock-outline</v-icon>
              <span>Quick Booking</span>
            </div>
            <div class="meta-item">
              <v-icon color="#f46523">mdi-shield-check</v-icon>
              <span>Verified Professionals</span>
            </div>
            <div class="meta-item">
              <v-icon color="#f46523">mdi-cash-multiple</v-icon>
              <span>Best Price</span>
            </div>
          </div>
        </div>
        <div
          v-if="resolvedServiceDetails && resolvedServiceDetails.length"
          class="service-details-section mb-12 animate-slide-up"
        >
          <div class="section-header mb-6">
            <h2 class="section-title">
              <v-icon color="#f46523" class="mr-3">mdi-cog</v-icon>
              What's Included
            </h2>
            <p class="section-subtitle">Comprehensive service breakdown</p>
          </div>
          <v-row>
            <v-col
              v-for="(detail, i) in resolvedServiceDetails"
              :key="i"
              cols="12"
              sm="6"
              md="6"
            >
              <v-card class="detail-card" elevation="0">
                <div class="detail-icon-wrapper">
                  <v-icon :color="getIconColor(i)" size="40">{{
                    getIcon(i)
                  }}</v-icon>
                </div>
                <h3 class="detail-title">{{ detail.title }}</h3>
                <p class="detail-description">{{ detail.description }}</p>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div
          v-if="service.basePrices && service.basePrices.length"
          class="pricing-section mb-12 animate-slide-up delay-1"
        >
          <!-- <div class="section-header mb-6">
            <h2 class="section-title">
              <v-icon color="#f46523" class="mr-3">mdi-tag-multiple</v-icon>
              Pricing Plans
            </h2>
            <p class="section-subtitle">
              Transparent and competitive pricing for all services
            </p>
          </div> -->
          <div class="modern-table-wrapper">
            <table class="modern-pricing-table">
              <thead>
                <tr>
                  <th class="table-header">
                    <div class="header-content">
                      <v-icon small color="#f46523">mdi-shape</v-icon>
                      <span>Category</span>
                    </div>
                  </th>
                  <th class="table-header">
                    <div class="header-content">
                      <v-icon small color="#f46523">mdi-layers</v-icon>
                      <span>Service Type</span>
                    </div>
                  </th>
                  <!-- <th class="table-header text-right">
                    <div class="header-content justify-end">
                      <span>Price</span>
                    </div>
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(price, i) in service.basePrices"
                  :key="i"
                  class="table-row"
                >
                  <td class="table-cell">
                    <div class="cell-category">
                      <div class="category-badge">
                        {{ price.category }}
                      </div>
                    </div>
                  </td>
                  <td class="table-cell">
                    <div class="cell-subcategory">
                      {{ price.subCategory }}
                    </div>
                  </td>
                  <!-- <td class="table-cell text-right">
                    <div class="cell-price">
                      <span class="price-value">{{ price.amount }}</span>
                    </div>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          v-if="service.checklist && service.checklist.length"
          class="checklist-section mb-12 animate-slide-up delay-2"
        >
          <div class="section-header mb-6">
            <h2 class="section-title">
              <v-icon color="#f46523" class="mr-3"
                >mdi-checkbox-marked-circle</v-icon
              >
              Service Includes
            </h2>
            <p class="section-subtitle">Everything covered in this service</p>
          </div>

          <v-card class="checklist-card" elevation="0">
            <v-row>
              <v-col
                v-for="(item, i) in service.checklist"
                :key="i"
                cols="12"
                sm="6"
                md="4"
              >
                <div class="checklist-item">
                  <v-icon color="#f46523" class="check-icon"
                    >mdi-check-circle</v-icon
                  >
                  <span class="check-text">{{ item }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <div
          v-if="service.faq && service.faq.length"
          class="faq-section animate-slide-up delay-3"
        >
          <div class="section-header mb-6">
            <h2 class="section-title">
              <v-icon color="#f46523" class="mr-3">mdi-help-circle</v-icon>
              Frequently Asked Questions
            </h2>
            <p class="section-subtitle">Got questions? We've got answers</p>
          </div>

          <v-expansion-panels class="faq-panels" flat>
            <v-expansion-panel
              v-for="(faq, i) in service.faq"
              :key="i"
              class="faq-panel"
            >
              <v-expansion-panel-header class="faq-header">
                <div class="faq-question">
                  <v-icon color="#f46523" class="mr-3" small
                    >mdi-comment-question</v-icon
                  >
                  {{ faq.question }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="faq-content">
                {{ faq.answer }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <!-- CTA Section -->
        <div class="cta-section mt-16 animate-fade-in delay-4">
          <v-card class="cta-card" elevation="0">
            <div class="cta-content">
              <h3 class="cta-title">Ready to Get Started?</h3>
              <p class="cta-subtitle">
                Book your service now and experience professional care
              </p>
              <div class="cta-buttons">
                <v-btn
                  @click="$router.push('/contact')"
                  x-large
                  color="#f46523"
                  depressed
                  dark
                  class="cta-btn-primary"
                >
                  Book This Service
                  <v-icon right>mdi-calendar-check</v-icon>
                </v-btn>
                <v-btn x-large outlined color="#f46523" class="cta-btn-primary">
                  Contact Support
                  <v-icon right>mdi-phone</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
      <div v-else class="not-found animate-fade-in">
        <v-icon size="120" color="rgba(255,255,255,0.2)"
          >mdi-alert-circle-outline</v-icon
        >
        <h2 class="not-found-title">Service Not Found</h2>
        <p class="not-found-text">
          Please check the URL or return to the services page.
        </p>
        <v-btn large color="#f46523" depressed dark class="mt-6" to="/">
          <v-icon left>mdi-arrow-left</v-icon>
          Back to Services
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import services from "../../data/services.json";

export default {
  name: "ServicesDetailedView",
  data() {
    return {
      service: null,
    };
  },
  computed: {
    currencySymbol() {
      // Check if user is from US based on route or localStorage
      const isUS =
        this.$route.meta?.location === "us" ||
        localStorage.getItem("isUS") === "true";
      return isUS ? "$" : "₹";
    },
    isUS() {
      return (
        this.$route.meta?.location === "us" ||
        localStorage.getItem("isUS") === "true"
      );
    },

    resolvedServiceDetails() {
      if (!this.service || !this.service.serviceDetails) return [];
      return this.isUS
        ? this.service.serviceDetails.us || []
        : this.service.serviceDetails.india || [];
    },
  },
  methods: {
    getIcon(index) {
      const iconSets = {
        cleaning: [
          "mdi-spray-bottle",
          "mdi-silverware-fork-knife",
          "mdi-bed",
          "mdi-broom",
          "mdi-sofa",
          "mdi-information",
        ],
        ac: ["mdi-air-filter", "mdi-snowflake", "mdi-water-check", "mdi-gauge"],
        default: [
          "mdi-wrench",
          "mdi-tools",
          "mdi-cog",
          "mdi-hammer-wrench",
          "mdi-clipboard-check",
          "mdi-star-circle",
        ],
      };

      let icons = iconSets.default;
      if (this.service && this.service.service) {
        const serviceName = this.service.service.toLowerCase();
        if (serviceName.includes("clean")) {
          icons = iconSets.cleaning;
        } else if (
          serviceName.includes("ac") ||
          serviceName.includes("air conditioner")
        ) {
          icons = iconSets.ac;
        }
      }

      return icons[index % icons.length];
    },
    getIconColor(index) {
      const colors = [
        "#f46523",
        "#ff8c42",
        "#ff6b35",
        "#f4a261",
        "#ff7f50",
        "#fd7e14",
      ];
      return colors[index % colors.length];
    },
  },
  created() {
    const routeName = this.$route.params.serviceName;
    this.service = services.find(
      (s) =>
        s.service.toLowerCase().replace(/\s+/g, "-") ===
        routeName.toLowerCase().replace(/\s+/g, "-"),
    );
  },
  watch: {
    "$route.params.serviceName"(newVal) {
      this.service = services.find(
        (s) =>
          s.service.toLowerCase().replace(/\s+/g, "-") ===
          newVal.toLowerCase().replace(/\s+/g, "-"),
      );
    },
  },
};
</script>

<style scoped>
.service-detail-page {
  position: relative;
  min-height: 100vh;
  background: white;
  overflow: hidden;
}

.hero-gradient-overlay {
  position: absolute;
  inset: 0;
  background: url("https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&q=80")
    center/cover no-repeat;
  opacity: 0.08;
  z-index: 0;
  animation: bgPulse 20s ease-in-out infinite;
}

@keyframes bgPulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.08;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.12;
  }
}

.floating-shapes {
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: 1;
}

.shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.1;
  animation: float 25s infinite ease-in-out;
}

.shape-1 {
  width: 500px;
  height: 500px;
  background: #f46523;
  top: -150px;
  right: -150px;
}

.shape-2 {
  width: 400px;
  height: 400px;
  background: #ff8c42;
  bottom: -100px;
  left: 10%;
  animation-delay: 8s;
}

.shape-3 {
  width: 350px;
  height: 350px;
  background: #f46523;
  top: 50%;
  right: 15%;
  animation-delay: 15s;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(40px, -40px) scale(1.1);
  }
  66% {
    transform: translate(-30px, 30px) scale(0.9);
  }
}

.main-section {
  position: relative;
  z-index: 2;
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}

.service-hero {
  text-align: center;
  padding: 60px 20px;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  background: rgba(244, 101, 35, 0.15);
  border: 1px solid rgba(244, 101, 35, 0.3);
  border-radius: 50px;
  color: black;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  backdrop-filter: blur(10px);
}

.service-title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  letter-spacing: -1px;
  background: #f46523;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.service-description {
  font-size: 1rem;
  color: black;
  line-height: 1.8;
  max-width: 1000px;
  margin: 0 auto;
}

.service-meta {
  display: flex;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: black;
  font-weight: 500;
  backdrop-filter: blur(10px);
}

.section-header {
  text-align: center;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: black;
  font-weight: 400;
}

.service-details-section {
  margin-top: 60px;
}

.detail-card {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid #f46523 !important;
  border-radius: 20px !important;
  padding: 32px 28px;
  height: 100%;
  backdrop-filter: blur(10px);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.detail-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #f46523, #ff8c42);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.detail-card:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  border-color: rgba(244, 101, 35, 0.4) !important;
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(244, 101, 35, 0.2);
}

.detail-card:hover::before {
  transform: scaleX(1);
}

.detail-icon-wrapper {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(244, 101, 35, 0.1);
  border: 2px solid rgba(244, 101, 35, 0.2);
  border-radius: 20px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.detail-card:hover .detail-icon-wrapper {
  background: rgba(244, 101, 35, 0.2);
  border-color: rgba(244, 101, 35, 0.4);
  transform: scale(1.1) rotate(5deg);
}

.detail-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: black;
  margin-bottom: 16px;
  line-height: 1.3;
}

.detail-description {
  font-size: 1rem;
  color: black;
  line-height: 1.8;
  margin: 0;
}

.modern-table-wrapper {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 8px;
  backdrop-filter: blur(20px);
  overflow: hidden;
}

.modern-pricing-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
}

.modern-pricing-table thead {
  position: relative;
}

.table-header {
  background: linear-gradient(
    135deg,
    rgba(244, 101, 35, 0.15) 0%,
    rgba(244, 101, 35, 0.05) 100%
  );
  padding: 20px 24px;
  font-weight: 700;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: black;
  border: none;
}

.table-header:first-child {
  border-radius: 12px 0 0 12px;
}

.table-header:last-child {
  border-radius: 0 12px 12px 0;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-content.justify-end {
  justify-content: flex-end;
}

.table-row {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
  position: relative;
}

.table-row:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(244, 101, 35, 0.3);
  transform: translateX(8px);
  box-shadow:
    -4px 0 0 #f46523,
    0 8px 24px rgba(244, 101, 35, 0.15);
}

.table-cell {
  padding: 24px;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  position: relative;
}

.table-row .table-cell:first-child {
  border-radius: 12px 0 0 12px;
}

.table-row .table-cell:last-child {
  border-radius: 0 12px 12px 0;
}

.cell-category {
  display: inline-flex;
}

.category-badge {
  display: inline-block;
  padding: 8px 20px;
  background: linear-gradient(135deg, #f46523 0%, #ff8c42 100%);
  border-radius: 50px;
  color: #fff;
  font-weight: 700;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 12px rgba(244, 101, 35, 0.3);
}

.cell-subcategory {
  font-weight: 600;
  font-size: 1.1rem;
  color: black;
  line-height: 1.4;
}

.cell-price {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
}

.price-value {
  font-size: 2rem;
  font-weight: 800;
  color: #f46523;
  font-family: "Inter", sans-serif;
  letter-spacing: -0.5px;
}

.checklist-card {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 20px !important;
  padding: 40px 32px;
  backdrop-filter: blur(10px);
}

.checklist-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 0;
}

.check-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.check-text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  line-height: 1.6;
  font-weight: 500;
}

.faq-panels {
  background: transparent !important;
}

.faq-panel {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 16px !important;
  margin-bottom: 16px !important;
  overflow: hidden;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.faq-panel:hover {
  border-color: rgba(244, 101, 35, 0.3) !important;
}

.faq-panel::before {
  display: none !important;
}

.faq-header {
  color: black !important;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
  padding: 24px 28px !important;
}

.faq-question {
  display: flex;
  align-items: center;
  width: 100%;
}

.faq-content {
  color: black !important;
  font-size: 1rem !important;
  line-height: 1.8 !important;
  padding: 0 28px 24px 28px !important;
}

.cta-card {
  background: white !important;
  border: 2px solid rgba(244, 101, 35, 0.3) !important;
  border-radius: 24px !important;
  padding: 60px 40px;
  text-align: center;
  backdrop-filter: blur(20px);
}

.cta-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: black;
  margin-bottom: 16px;
}

.cta-subtitle {
  font-size: 1.2rem;
  color: black;

  margin-bottom: 32px;
}

.cta-buttons {
  display: flex;
  gap: 11px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn-primary,
.cta-btn-secondary {
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  font-weight: 600 !important;
  border-radius: 12px !important;
  padding: 10px 48px !important;
  height: auto !important;
  font-size: 1.1rem !important;
}

.cta-btn-secondary {
  border: 2px solid #f46523 !important;
}

.not-found {
  text-align: center;
  padding: 100px 20px;
}

.not-found-title {
  font-size: 2rem;
  color: #fff;
  font-weight: 700;
  margin: 24px 0 16px;
}

.not-found-text {
  font-size: 1.1rem;
}

/* Animations */
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fade-in 0.8s ease forwards;
}

.animate-slide-up {
  animation: slide-up 0.8s ease forwards;
}

.delay-1 {
  animation-delay: 0.2s;
}
.delay-2 {
  animation-delay: 0.4s;
}
.delay-3 {
  animation-delay: 0.6s;
}
.delay-4 {
  animation-delay: 0.8s;
}

/* Responsive */
@media (max-width: 960px) {
  .service-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 1.8rem;
    flex-direction: column;
  }

  .service-meta {
    gap: 16px;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .cta-btn-primary,
  .cta-btn-secondary {
    width: 100%;
  }

  .modern-table-wrapper {
    overflow-x: auto;
    border-radius: 16px;
  }

  .modern-pricing-table {
    min-width: 600px;
  }

  .table-cell {
    padding: 16px;
  }

  .price-value {
    font-size: 1.5rem;
  }
}

@media (max-width: 600px) {
  .service-hero {
    padding: 40px 16px;
  }

  .cta-card {
    padding: 40px 24px;
  }

  .detail-card {
    padding: 24px 20px;
  }

  .detail-icon-wrapper {
    width: 64px;
    height: 64px;
  }

  .detail-title {
    font-size: 1.2rem;
  }

  .detail-description {
    font-size: 0.95rem;
  }

  .modern-table-wrapper {
    padding: 4px;
  }

  .table-header {
    padding: 16px 12px;
    font-size: 0.75rem;
  }

  .table-cell {
    padding: 12px;
    font-size: 0.9rem;
  }

  .category-badge {
    padding: 6px 12px;
    font-size: 0.75rem;
  }

  .cell-subcategory {
    font-size: 0.95rem;
  }

  .price-value {
    font-size: 1.3rem;
  }

  .modern-pricing-table {
    min-width: 500px;
  }
}
</style>
